import { statusToneMap } from "@/lib/format";
import { cn } from "@/lib/utils";

const TONE_CLASSES = {
    success: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 ring-emerald-500/20",
    warning: "bg-amber-500/10 text-amber-700 dark:text-amber-400 ring-amber-500/20",
    destructive: "bg-red-500/10 text-red-700 dark:text-red-400 ring-red-500/20",
    info: "bg-blue-500/10 text-blue-700 dark:text-blue-400 ring-blue-500/20",
    muted: "bg-muted text-muted-foreground ring-border",
};

export default function StatusPill({ status, className, testid }) {
    const tone = statusToneMap[status] || "muted";
    return (
        <span
            data-testid={testid}
            className={cn(
                "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ring-inset uppercase tracking-wide",
                TONE_CLASSES[tone],
                className
            )}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-current" />
            {(status || "").replace(/_/g, " ")}
        </span>
    );
}
